import type { PapiDaSharedCommissionList } from '@wix/da-papi-types';
import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { withOffset } from '../../Stream';
import type { FetchAction } from '../../Stream/base/types';
import { requestPuppy } from '@wix/da-http-client';
import { FetchType } from '../../Stream/base/types';

export function fakeResponse({ params }): any {
  if (process.env.NODE_ENV !== 'production') {
    const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
    const { Chance } = require('chance'); // eslint-disable-line global-require
    if (window.doError) {
      return {
        error: 'invalid_request',
        error_description: 'Not logged in.',
        status: 'error',
      };
    }

    const randomDeviations = new Chance().pickset(deviationsByType.commissions, 10);

    return {
      hasMore: false,
      deviations: randomDeviations,
    };
  }
}

function* fetch(url: string, params: object) {
  const response = yield call(
    requestPuppy,
    {
      method: 'get',
      url,
      params,
    },
    fakeResponse
  );
  return response;
}

function* handleCommissionStreamFetch(action: FetchAction): SagaIterator {
  const { streamId } = action;

  const offset = yield select(state => withOffset.selectors.getNextOffset(state, streamId));

  const response: PapiDaSharedCommissionList | false = yield call(fetch, 'commission/list', {
    offset,
  });

  if (!response) {
    yield put(
      withOffset.actions.fetchFailure({
        streamId,
        fetchType: FetchType.Next,
        errorMsg: 'Failed to fetch',
      })
    );
    return;
  }

  const { deviations, hasMore, nextOffset } = response;
  const normalized = deviations && normalizeDeviations(deviations);

  yield put(
    withOffset.actions.fetchSuccess({
      streamId,
      hasMore: !!hasMore,
      nextOffset,
      items: normalized?.result ?? [],
      entities: normalized?.entities ?? {},
    })
  );
}

export default handleCommissionStreamFetch;
